import React, { useRef, useCallback } from "react";
import "./style.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import Button from "../CtaButton";

const SimilerBanner = ({
  mainHeading,
  sideImage,
  btnText,
  btnText2,
  content,
  subHeading,
  greenHeading,
  diffBannerBackgroundImage,
}) => {
  return (
    <>
      <div className="main-banner-box" style={diffBannerBackgroundImage}>
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 flex-center-banner-box">
              <h2 className="banner-heading">
                {mainHeading} <span>{greenHeading}</span>
              </h2>

              <h3 className="subHeading-banner">{subHeading}</h3>

              <p className="banner-sub-heading">{content}</p>

              <div className="mt-2 mt-md-4 d-flex flex-wrap gap-3">
                {!btnText ? (
                  ""
                ) : (
                  <a
                    href="https://calendly.com/bitsclansolutions/15min"
                    target="_blank"
                    className="what-we-do-banner-button"
                  >
                    {btnText}
                  </a>
                )}

                {!btnText2 ? (
                  ""
                ) : (
                  // <Link
                  //   to="/contact-us"
                  //   className="what-we-do-banner-button"
                  //   type="btn"
                  // >
                  //   {btnText2}
                  // </Link>

                  <Button link="/contact-us" text={btnText2} />
                )}
              </div>
            </div>

            {sideImage && (
              <div className="col-md-6 mt-5 mt-md-0">
                <div className="banner-vedio-side-image">
                  <img src={`/images/${sideImage}`} alt={`${sideImage}`} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SimilerBanner;
